import { useEffect } from 'react';

const BASE_URL = 'https://pathproxy.com';

const SEO = ({ title, description, path = '', noindex = false }) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | PathProxy`
      : 'PathProxy — Premium Residential & Rotating Proxy Services | 40M+ IPs';
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }

    setMeta('property', 'og:title', fullTitle);
    setMeta('name', 'twitter:title', fullTitle);

    const canonicalUrl = `${BASE_URL}${path}`;
    setMeta('property', 'og:url', canonicalUrl);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    if (noindex) {
      setMeta('name', 'robots', 'noindex, nofollow');
    } else {
      setMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    }

    return () => {
      document.title = 'PathProxy — Premium Residential & Rotating Proxy Services | 40M+ IPs';
    };
  }, [title, description, path, noindex]);

  return null;
};

export default SEO;
